import { render, staticRenderFns } from "./EditarPerdaDeQualificacaoOscip.vue?vue&type=template&id=03b1328c"
import script from "./EditarPerdaDeQualificacaoOscip.vue?vue&type=script&lang=ts"
export * from "./EditarPerdaDeQualificacaoOscip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports